export enum StepAccountRegistrationEnum {
  PHONE = 'phone',
  CODE = 'code',
  PASSWORD = 'password',
  INFO = 'info',
  COMPLETE = 'complete'
}

export enum AccountRoleEnum {
  ADMIN = 'admin',
  MODERATOR = 'moderator',
  EDITOR = 'editor',
  USER = 'user',
}

export enum AccountAuthLogEventEnum {
  SIGN_IN_SUCCESS = 'sign_in_success',
  SIGN_IN_FAILED = 'sign_in_failed',
}

export enum StepAccountResetPasswordEnum {
  PHONE = 'phone',
  CODE = 'code',
  PASSWORD = 'password',
  COMPLETE = 'complete'
}
